export const fixedMobileCTA = (theme) => ({
  cta: {
    color: `${theme.customPalette.grapePurple} !important`,
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    textTransform: 'initial',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  ctaContainer: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      zIndex: theme.zIndex.appBar,
      background: 'white',
      padding: theme.spacing(2),
    },
  },
  icon: {
    height: 24,
    width: 'auto',
    paddingLeft: theme.spacing(1),
  },
});
